module.exports = __webpack_public_path__ + "static/media/orange-wheel.21f332bf.png";